// extracted by mini-css-extract-plugin
export default {"week":"styles_week__IxfJL","weekDay":"styles_weekDay__WZFNp"};